
import React from 'react';
import CGVContent from '../components/shared/CGVContent';

const CGV = () => {
  console.log("CGV: Rendering page");
  
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-2xl sm:text-3xl font-bold mb-6 sm:mb-8">Conditions Générales de Ventes</h1>
      <CGVContent />
    </div>
  );
};

export default CGV;
